<template>
  <div>
    <headTop></headTop>
    <div class="cssOrderdetail">
      <div class="cssOrderdetailMapping">
        <span class="cssOrderdetailTitle">应急保障</span>
        <span class="cssOrderdetailSubTitle">— 订单详情</span>
        <div class="cssBack" @click="$router.back(-1)">返回上一步 ></div>
      </div>

      <div class="cssOrderInfo">
        <p class="cssOrderInfoTit">订单信息</p>
        <p class="cssOrderInfoDetail">订单号：</p><span class="cssInnerText">{{orderdetail.order_id || '-'}}</span>
        <p class="cssOrderInfoDetail">订单时间：</p><span class="cssInnerText">{{orderdetail.created_time || '-'}}</span>
        <div v-if="has_security">
          <p class="cssOrderInfoDetail">安保费：</p><span class="cssInnerText">{{orderdetail.security_money || '-'}}元</span>
        </div>
        <div v-if="has_car">
          <p class="cssOrderInfoDetail">消防车租凭费：</p><span class="cssInnerText">{{orderdetail.car_rental_money}}元</span>
        </div>
        <p class="cssOrderInfoDetail">方案总价：</p><span class="cssInnerText">{{orderdetail.count_money || '-'}}元</span>
        <div v-if="orderdetail.tails.payOrder.pay_state == '已付款'">
          <p class="cssOrderInfoDetail">实付金额：</p><span class="cssInnerText">{{orderdetail.tails.payOrder.amount}}元</span>
        </div>
        <p class="cssOrderInfoDetail">付款时间：</p><span class="cssInnerText">{{formatTime(orderdetail.tails.payOrder.pay_time) || '-'}}</span>
        <p class="cssOrderInfoDetail">支付方式：</p><span class="cssInnerText">{{orderdetail.tails.payOrder.channel || '-'}}</span>
        <p class="cssOrderInfoDetail">订单状态：</p><span v-if="orderdetail.tails.payOrder.order_state == '失效' || orderdetail.tails.payOrder.order_state == '已取消'" class="cssInnerText">已关闭</span>
        <span v-else-if="orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.tails.contract_online_status == '待实名' && orderdetail.tails.payOrder.tails.contract_on_line == 1" class="cssInnerText">待实名</span>
        <span v-else-if="orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.tails.contract_online_status == '待认证' && orderdetail.tails.payOrder.tails.contract_on_line == 1" class="cssInnerText">待认证</span>
        <span v-else-if="orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.tails.contract_online_status == '待授权' && orderdetail.tails.payOrder.tails.contract_on_line == 1" class="cssInnerText">待授权</span>
        <span v-else-if="orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.tails.contract_online_status == '待签署' && orderdetail.tails.payOrder.tails.contract_on_line == 1" class="cssInnerText">待签署</span>
        <span v-else-if="orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.tails.contract_online_status == '待签署' && orderdetail.tails.payOrder.tails.status == '已发起' && orderdetail.tails.payOrder.tails.contract_on_line == 1" class="cssInnerText">等待签署完成</span>
        <span v-else-if="orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.tails.contract_on_line == 0 && orderdetail.tails.payOrder.channel == '线下汇款'" class="cssInnerText">汇款审核中</span>
        <span v-else-if="orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.tails.contract_on_line == 0 && !orderdetail.tails.payOrder.channel" class="cssInnerText">待付款</span>
        <span v-else-if="orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.tails.contract_on_line == 1 && orderdetail.tails.payOrder.channel == '线下汇款'" class="cssInnerText">汇款审核中</span>
        <span v-else-if="orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.tails.contract_on_line == 1 && !orderdetail.tails.payOrder.channel" class="cssInnerText">待付款</span>
        <!-- <span v-else-if="orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.tails.contract_on_line == 1 && orderdetail.tails.payOrder.channel != '线下汇款'" class="cssInnerText">待付款</span> -->
        <span v-else-if="orderdetail.tails.payOrder.pay_state == '已付款' && orderdetail.tails.payOrder.tails.acceptance_status == 0" class="cssInnerText">待验收</span>
        <span v-else-if="orderdetail.tails.payOrder.pay_state == '已付款' && orderdetail.tails.payOrder.tails.acceptance_status == 1" class="cssInnerText">交易完成</span>
      </div>
      <div class="cssServeInfo">
        <p class="cssOrderInfoTit">服务信息</p>
        <p class="cssOrderInfoDetail">联系人：</p><span class="cssInnerText">{{orderdetail.user_name || '-'}}</span>
        <p class="cssOrderInfoDetail">联系人手机号：</p><span class="cssInnerText">{{orderdetail.phone || '-'}}</span>
        <p class="cssOrderInfoDetail">项目地址：</p><span class="cssInnerText">{{orderdetail.logistics_match || '-'}}&nbsp;{{orderdetail.city || '-'}}&nbsp;{{orderdetail.area || '-'}}&nbsp;{{orderdetail.address_detail || '-'}}</span>
      </div>
      <div class="cssNeedInfo">
        <p class="cssOrderInfoTit">需求信息</p>
        <p class="cssOrderInfoDetail">场所选择：</p><span class="cssInnerText">{{orderdetail.place || '-'}}</span>
        <p class="cssOrderInfoDetail">需求选择：</p><span class="cssInnerText">{{orderdetail.demand || '-'}}</span>
        <p class="cssOrderInfoDetail">客户属性：</p><span class="cssInnerText">{{orderdetail.customer_property || '-'}}</span>
        <p class="cssOrderInfoDetail">租赁需求：</p><span class="cssInnerText">{{orderdetail.lease_types || '-'}}</span>
        <div v-if="has_security">
          <p class="cssOrderInfoDetail">安保类型：</p><span v-if="orderdetail.security_type == 1" class="cssInnerText">单班保障</span>
          <span v-if="orderdetail.security_type == 2" class="cssInnerText">双班保障</span>
          <span v-if="orderdetail.security_type == 3" class="cssInnerText">三班保障</span>
        </div>
        <div v-if="has_security">
          <p class="cssOrderInfoDetail">需求周期：</p><span class="cssInnerText">{{orderdetail.security_demand_start || '-'}} 至 {{orderdetail.security_demand_end || '-'}} 共{{orderdetail.tails.daySub_security || '-'}}天 （工作节点
            {{orderdetail.security_actual_end_date+'  '+orderdetail.work_time_end || '-'}}）</span>
        </div>
        <div v-if="has_security">
          <p class="cssOrderInfoDetail">工作时间：</p><span class="cssInnerText">{{orderdetail.work_time_start}} - {{orderdetail.work_time_end || '-'}}</span>
        </div>
        <div v-if="has_security">
          <p class="cssOrderInfoDetail">安保人数：</p><span class="cssInnerText" v-if="orderdetail.security_type == 1">{{orderdetail.security_guard_num || '-'}}位 &nbsp;&nbsp;&nbsp;单班保障共{{orderdetail.security_guard_num*orderdetail.security_type || '-'}}位/天</span>
          <span class="cssInnerText" v-else-if="orderdetail.security_type == 2">{{orderdetail.security_guard_num || '-'}}位 &nbsp;&nbsp;&nbsp;双班保障共{{orderdetail.security_guard_num*orderdetail.security_type || '-'}}位/天</span>
          <span class="cssInnerText" v-else-if="orderdetail.security_type == 3">{{orderdetail.security_guard_num || '-'}}位 &nbsp;&nbsp;&nbsp;三班保障共{{orderdetail.security_guard_num*orderdetail.security_type || '-'}}位/天</span>
        </div>
        <div v-if="has_car">
          <p class="cssOrderInfoDetail">消防车租凭：</p><span class="cssInnerText">{{orderdetail.car_rental_num || '-'}} 辆</span>
        </div>
        <div v-if="has_car">
          <p class="cssOrderInfoDetail">需求周期：</p><span class="cssInnerText">{{orderdetail.car_rental_start || '-'}} 至 {{orderdetail.car_rental_end || '-'}} 共 {{orderdetail.tails.daySub_car || '-'}} 天</span>
        </div>
      </div>
      <div v-if="orderdetail.tails.payOrder.order_state != '失效' &&
                 orderdetail.tails.payOrder.order_state != '已取消' &&
                 orderdetail.tails.payOrder.pay_state == '未付款'" class="cssBlankArea">
        <!-- 底部占位  order_state-->
      </div>
      <div class="outer" v-if="orderdetail.tails.payOrder.order_state != '失效' && orderdetail.tails.payOrder.order_state != '已取消' && orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.channel != '线下汇款' && orderdetail.tails.payOrder.tails.contract_online_status == '待实名'&& orderdetail.tails.payOrder.tails.contract_on_line == 1"><button @click="goToContract(orderdetail.tails.payOrder.tails.solutionsId)" class="bottomJump">实名认证</button></div>
      <div class="outer" v-else-if="orderdetail.tails.payOrder.order_state != '失效' && orderdetail.tails.payOrder.order_state != '已取消' && orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.channel != '线下汇款' && orderdetail.tails.payOrder.tails.contract_online_status == '待认证'&& orderdetail.tails.payOrder.tails.contract_on_line == 1"><button @click="goToCompContract(orderdetail.tails.payOrder.tails.solutionsId)" class="bottomJump">企业认证</button></div>
      <div class="outer" v-else-if="orderdetail.tails.payOrder.order_state != '失效' && orderdetail.tails.payOrder.order_state != '已取消' && orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.channel != '线下汇款' && orderdetail.tails.payOrder.tails.contract_online_status == '待授权'&& orderdetail.tails.payOrder.tails.contract_on_line == 1"><button @click="sendContract(orderdetail.tails.payOrder.tails.solutionsId)" class="bottomJump">发送授权</button></div>
      <div class="outer" v-else-if="orderdetail.tails.payOrder.order_state != '失效' && orderdetail.tails.payOrder.order_state != '已取消' && orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.channel != '线下汇款' && orderdetail.tails.payOrder.tails.contract_online_status == '待签署'&& orderdetail.tails.payOrder.tails.contract_on_line == 1"><button @click="goSignContract(orderdetail.tails.payOrder.tails.solutionsId)" class="bottomJump">签署合同</button></div>
      <!-- <div class="outer" v-else-if="orderdetail.tails.payOrder.order_state != '失效' && orderdetail.tails.payOrder.order_state != '已取消' && orderdetail.tails.payOrder.pay_state == '已付款' && orderdetail.tails.payOrder.tails.acceptance_status == 0"><button @click="goAcceptance(orderdetail.tails.payOrder.tails.solutionsId)" class="bottomJump" >项目验收</button></div> -->
      <bottomButton v-if="orderdetail.tails.payOrder.order_state != '失效' && orderdetail.tails.payOrder.order_state != '已取消' && orderdetail.tails.payOrder.pay_state == '未付款' && orderdetail.tails.payOrder.tails.contract_on_line == 0 && orderdetail.tails.payOrder.channel != '线下汇款'" title="支付" :state="5" @click="applyClick(orderdetail.order_id,orderdetail.count_money)"></bottomButton>
      <bottomButton v-else-if="orderdetail.tails.payOrder.order_state != '失效'
                             && orderdetail.tails.payOrder.order_state != '已取消'
                             && orderdetail.tails.payOrder.pay_state == '未付款'
                             && orderdetail.tails.payOrder.tails.contract_on_line == 1
                             && orderdetail.tails.payOrder.channel != '线下汇款'
                             && orderdetail.tails.payOrder.tails.contract_online_status != '待实名'
                             && orderdetail.tails.payOrder.tails.contract_online_status != '待认证'
                             && orderdetail.tails.payOrder.tails.contract_online_status != '待授权'
                             && orderdetail.tails.payOrder.tails.contract_online_status != '待签署'" title="支付" :state="5" @click="applyClick(orderdetail.order_id,orderdetail.count_money)"></bottomButton>
    </div>
    <!--  支付弹窗  -->
    <payView type="5" :show="payViewVisible" :orderId="orderdetail.order_id" :money="orderdetail.count_money" @payValue="payValue"></payView>
  </div>
</template>
<script>
import headTop from './header';
import bottomButton from '../components/bottom-button';
import payView from '../components/pay';

export default {
  name: 'orderdetail',
  data () {
    return {
      currentId: this.$route.query.orderid || '1181820967563821056',
      innerText: [],
      has_car: false,
      has_security: false,
      payamount: '',
      orderdetail: {
        tails: {
          payOrder: {}
        }
      },
      // url: Utils.SERVER1,
      payViewVisible: false
    }
  },
  mounted () {
    this.getData(this.currentId)
  },
  methods: {
    // 时间转化函数
    formatTime (ndate) {
      if (!ndate) {
        return '-';
      }
      var date = new Date(ndate * 1000)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var minute = date.getMinutes()
      var second = date.getSeconds()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (day >= 0 && day <= 9) {
        day = '0' + day
      }
      if (hour >= 0 && hour <= 9) {
        hour = '0' + hour
      }
      if (minute >= 0 && minute <= 9) {
        minute = '0' + minute
      }
      if (second >= 0 && second <= 9) {
        second = '0' + second
      }
      var result = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
      return result
    },

    getData (id) {
      var _this = this
      this.utils.GET(this.companyUrl + '/zxOrder/detailsOfSolutions?orderId=' + id, function (res) {
        if (res.code === 0) {
          console.log(res.data)
          _this.orderdetail = res.data
          _this.payamount = res.data.tails.payOrder.amount
          if (_this.orderdetail.lease_types.indexOf('安保人员') !== -1) {
            _this.has_security = true
            _this.orderdetail.security_demand_start = _this.orderdetail.security_demand_start.split(' ')[0]
            _this.orderdetail.security_demand_end = _this.orderdetail.security_demand_end.split(' ')[0]
            _this.orderdetail.security_money = _this.money_dot(_this.orderdetail.security_money)
          }
          if (_this.orderdetail.lease_types.indexOf('消防车租赁') !== -1) {
            _this.has_car = true
            _this.orderdetail.car_rental_start = _this.orderdetail.car_rental_start.split(' ')[0]
            _this.orderdetail.car_rental_end = _this.orderdetail.car_rental_end.split(' ')[0]
            _this.orderdetail.car_dispatching_money = _this.money_dot(_this.orderdetail.car_dispatching_money)
            _this.orderdetail.car_rental_money = _this.money_dot(_this.orderdetail.car_rental_money)
          }
          _this.orderdetail.count_money = _this.money_dot(_this.orderdetail.count_money)
          _this.orderdetail.tails.payOrder.amount = _this.money_dot(_this.orderdetail.tails.payOrder.amount)
          if (_this.orderdetail.tails.payOrder.channel === 'remittance') {
            _this.orderdetail.tails.payOrder.channel = '线下汇款'
          }
          if (_this.orderdetail.tails.payOrder.channel === 'alipay_pc_direct') {
            _this.orderdetail.tails.payOrder.channel = '支付宝'
          }
          if (_this.orderdetail.tails.payOrder.channel === 'wx_pub_qr') {
            _this.orderdetail.tails.payOrder.channel = '微信'
          }
          if (_this.orderdetail.work_time_start && _this.orderdetail.work_time_end) {
            if (_this.orderdetail.work_time_start.length < 5 && _this.orderdetail.work_time_end.length < 5) {
              _this.orderdetail.work_time_start = _this.orderdetail.work_time_start + ':00'
              _this.orderdetail.work_time_end = _this.orderdetail.work_time_end + ':00'
            }
          }
        }
      })
    },

    applyClick: function (id, amount) {
      this.payViewVisible = true
    },
    payValue: function (state) {
      this.payViewVisible = false
      console.log('============支付回调')
    },
    toTop () {
      // 滚动至顶部
      // document.documentElement.scrollTop=0
      document.documentElement.scrollTop = document.body.scrollTop = 0
    },
    dataURLtoBlob (dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },

    closeSucess () {
      this.sucess = false
      document.querySelector('body').style = 'overflow:auto';
    },
    // 实名认证
    goToContract (id) {
      this.$router.push({
        path: '/company-auth',
        query: {
          planId: id
        }
      })
    },

    // 企业认证
    goToCompContract (id) {
      this.$router.push({
        path: '/company-auth',
        query: {
          planId: id
        }
      })
    },

    // //更换签署
    // changeContract (id) {
    //   this.$router.push({
    //     path:'/company-auth',
    //     query:{
    //       orderid: id
    //     }
    //   })
    // },

    // 发送授权
    sendContract (id) {
      this.$router.push({
        path: '/company-auth',
        query: {
          planId: id
        }
      })
    },

    // 签署合同
    goSignContract (id) {
      this.$router.push({
        path: '/company-auth',
        query: {
          planId: id
        }
      })
    }

    // goAcceptance (id) {
    //   var _this = this
    //   this.utils.POST(this.companyUrl + '/zxOrder/acceptanceSolutions?sId=' + id, null, function (res) {
    //     if (res.code === 0) {
    //       _this.getOrderData()
    //     }
    //   })
    // }
  },
  components: {
    headTop,
    payView,
    bottomButton
  }
}
</script>
<style scoped>
body {
  height: 100%;
  padding-bottom: 60px;
}
.header {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
}
.cssOrderdetail {
  margin-top: 55px;
  font-size: 0;
  background: #f0f0f0;
}
.cssOrderdetail .cssOrderdetailMapping {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0 14px 0 15px;
  background: #ffffff;
  box-sizing: border-box;
  margin-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
}
.cssOrderdetail .cssOrderdetailMapping .cssOrderdetailTitle {
  font-weight: bold;
  font-size: 16px;
  color: #000;
  font-family: " MicrosoftYaHei-Bold ";
}
.cssOrderdetail .cssOrderdetailMapping .cssOrderdetailSubTitle {
  font-weight: bold;
  font-size: 14px;
  color: #000;
  font-family: " MicrosoftYaHei-Bold ";
}
.cssOrderdetail .cssOrderdetailMapping .cssBack {
  height: 30px;
  width: 80px;
  font-size: 13px;
  line-height: 30px;
  float: right;
  background: none;
  border: none;
  margin-top: 10px;
  color: #999999;
}
.cssOrderInfo {
  width: 100%;
  /* height: 363px; */
  background: #ffffff;
  padding: 20px 15px 20px 15px;
  margin: 0 0 10px 0;
  font-size: 0;
}
.cssOrderInfo .cssOrderInfoTit {
  display: block;
  height: 14.5px;
  width: 100%;
  text-align: left;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #000;
  font-size: 15px;
  margin-bottom: 28.5px;
}

.cssOrderInfoDetail {
  vertical-align: top;
  display: inline-block;
  height: 13px;
  width: 110px;
  text-align: left;
  font-family: SourceHanSansCN-Regular;
  color: #808080;
  font-size: 14px;
  margin-bottom: 25px;
}
.cssOrderInfoDetail:last-child {
  margin-bottom: 0px;
}
#OrderStatus,
.cssInnerText {
  display: inline-block;
  width: calc(100% - 110px);
  /* height: 11px; */
  text-align: left;
  font-family: SourceHanSansCN-Regular;
  color: #333333;
  font-size: 14px;
}

.cssServeInfo {
  width: 100%;
  /* height: 171.5px; */
  background: #ffffff;
  padding: 20px 15px 20px 15px;
  margin: 0 0 10px 0;
  font-size: 0;
}
.cssServeInfo .cssOrderInfoTit {
  display: block;
  height: 14.5px;
  width: 100%;
  text-align: left;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #000;
  font-size: 15px;
  margin-bottom: 28.5px;
}
.cssNeedInfo {
  width: 100%;
  /* height: 171.5px; */
  background: #ffffff;
  padding: 20px 15px 20px 15px;
  margin: 0 0 10px 0;
  font-size: 0;
}
.cssNeedInfo .cssOrderInfoTit {
  display: block;
  height: 14.5px;
  width: 100%;
  text-align: left;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #000;
  font-size: 15px;
  margin-bottom: 28.5px;
}
.cssBlankArea {
  height: 65px;
}
.outer {
  position: fixed;
  bottom: 0;
  height: 65px;
  width: 100%;
  padding: 10px 15px 10px 15px;
  background: #ffffff;
}
.bottomJump {
  width: 100%;
  line-height: 45px;
  font-size: 14px;
  color: #ffffff;
  background: #c41335;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/orderdetail.vue